import AdvertisingAdn from './advertising-adn';

export default AdvertisingAdn;
